var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 23 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M14.121 9.879 9.88 14.12M10.333 7 12 5.333a4.714 4.714 0 0 1 6.667 0v0a4.714 4.714 0 0 1 0 6.667L17 13.667M13.667 17 12 18.667a4.714 4.714 0 0 1-6.667 0v0a4.714 4.714 0 0 1 0-6.667L7 10.333"
})));
export default SvgLink;